import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';
import { ButtonRecipe, CheckboxRecipe } from './reciepe.style';
import { ColorStyles, FontSizeStyles, LetterSpacingStyles, RadiusStyles } from './token.style';
import TextStyles from './typography.style';

const config = defineConfig({
   cssVarsPrefix: 'cancard',
   globalCss: {
      '*': {
         scrollBehavior: 'smooth',
         fontFamily: 'var(--font-montserrat)',
      },
      '*::selection': {
         background: '-moz-initial',
      },
      '::-webkit-scrollbar': {
         width: '1',
         height: '1',
      },
      '::-webkit-scrollbar-track': {
         boxShadow: 'inset 0 0 5px',
         borderRadius: '2.5',
      },
      '::-webkit-scrollbar-thumb': {
         background: 'brand',
         borderRadius: '2.5',
      },
      '::-webkit-scrollbar-thumb:hover': {
         background: 'brand',
      },
      'li.country': {
         '&:hover': {
            background: '#222 !important',
         },
         '&.highlight': {
            background: '#444 !important',
         },
      },
      '.selected-flag': {
         background: 'none !important',
         border: 'none !important',
         '& .arrow': {
            borderLeft: '4px solid transparent !important',
            borderRight: '4px solid transparent !important',
            borderTop: '5px solid #fff !important',
            '&.up': {
               borderTop: 'none !important',
               borderBottom: '5px solid #fff !important',
            },
         },
         '&:hover': {
            background: 'none !important',
         },
      },
      '.flag-dropdown': {
         background: 'none !important',
         border: 'none !important',
      },
      '.flag': {
         marginLeft: '5px',
      },
      '.special-label': {
         display: 'none !important',
      },
      '.slick-dots': {
         paddingTop: '30px !important',
         bottom: '-40px !important',
         '& li': {
            width: '6px',
            height: '8px',
            borderRadius: '50%',
            background: '#D9D9D9',
            border: 'solid 5px #000',
            boxShadow: '0 0 1px 2px #000',
            '&.slick-active': {
               background: '#F5E876',
               boxShadow: '0 0 1px 2px #F5E876',
            },
            '& button': {
               '&::before': {
                  display: 'none',
               },
            },
         },
      },
   },
   theme: {
      textStyles: TextStyles,
      recipes: {
         button: ButtonRecipe,
      },
      slotRecipes: {
         checkbox: CheckboxRecipe,
      },
      tokens: {
         letterSpacings: LetterSpacingStyles,
         radii: RadiusStyles,
         colors: ColorStyles,
         fontSizes: FontSizeStyles,
      },
   },
});

const ThemeConfig = createSystem(defaultConfig, config);

export default ThemeConfig;
